import { BootstrapApi } from '../api/bootstrap/BootstrapApi';
import { NavigationApi } from '../api/NavigationApi';
import { Log } from '@lightningjs/sdk';
import { Backend } from '../api/Backend';

export class Login {
  static initSession(backend: Backend) {
    return BootstrapApi.sessionInfo(backend)
      .then(response => {
        backend.sessionInfo = response;
        return BootstrapApi.deviceProfile(backend, response.device.id);
      })
      .then(response => {
        backend.deviceProfile = response;
        return NavigationApi.menu(backend, response.profile.catalog);
      })
      .then(response => {
        backend.menu = response;
        return response;
      })
      .catch(err => {
        Log.error('Initialization failed', err);
      });
  }
}
